export function secondsToObj(seconds) {
  let secondsTotal = String(seconds % 60)
  let minutesTotal = String(Math.floor(seconds / 60) % 60)
  let hoursTotal = String(Math.floor(seconds / 3600))

  return{
    hh: parseInt(hoursTotal, 10),
    mm: parseInt(minutesTotal, 10),
    ss: parseInt(secondsTotal, 10),
    hhString: (hoursTotal.length === 1) ? '0' + hoursTotal : hoursTotal,
    mmString: (minutesTotal.length === 1) ? '0' + minutesTotal : minutesTotal,
    ssString: (secondsTotal.length === 1) ? '0' + secondsTotal : secondsTotal
    // Should add a string format here 01h 20m 50s format
  }
}

export function minutesToObj(minutes) {
  let hoursTotal = String(Math.floor(minutes / 60))
  let minutesTotal = String(minutes % 60)

  return{
    hh: parseInt(hoursTotal, 10),
    mm: parseInt(minutesTotal, 10),
    hhString: (hoursTotal.length === 1) ? '0' + hoursTotal : hoursTotal,
    mmString: (minutesTotal.length === 1) ? '0' + minutesTotal : minutesTotal,
  }
}

export function timeToImperialObj(timeIn24) {
  let time = timeIn24
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]

  if (time.length > 1) { // If time format correct
    time = time.slice(1)  // Remove full string match value
    time[5] = +time[0] < 12 ? 'AM' : 'PM' // Set AM/PM
    time[0] = +time[0] % 12 || 12 // Adjust hours
  }
  time[4] = ':'
  time = time.join('').replace(' ', ':').split(':')

  return {
    hh: time[0],
    mm: time[1],
    ss: time[2],
    A: time[3]
  }
}

export function imperialToTimeObj(time) {
  time = time.replace(' ', ':').match(/(\d+):(\d+):(\d+):(\w)/)
  var hours = Number(time[1])
  var minutes = Number(time[2])
  var seconds = Number(time[3])
  var meridian = time[4].toLowerCase()

  if (meridian === 'p' && hours < 12) {
    hours += 12
  } else if (meridian === 'a' && hours === 12) {
    hours -= 12
  }

  return{
    hh: hours,
    mm: minutes,
    ss: seconds,
    hhString: (hours.length === 1) ? '0' + hours : hours,
    mmString: (minutes.length === 1) ? '0' + minutes : minutes,
    ssString: (seconds.length === 1) ? '0' + seconds : seconds,
  }
}